// extracted by mini-css-extract-plugin
export default {"document":"AddDocument_document__OY9X6","campos":"AddDocument_campos__1Y6G2","botao":"AddDocument_botao__QSojO"};